"use client";

import { c as _c } from "react/compiler-runtime";
import type { Dispatch } from "react";
import { useCallback } from "react";
import type { AdditionalMedia, AirdropEntry, AllowlistBatchRaw, PaymentInfo } from "../types/OperationalData";
import { SubmissionStep } from "../types/Steps";
import type { TraitsData } from "../types/TraitsData";
import type { FormAction, FormState, ProfileDefaults } from "./artworkSubmissionFormState";
interface UseArtworkSubmissionFormActionsParams {
  readonly state: FormState;
  readonly dispatch: Dispatch<FormAction>;
  readonly profileDefaults?: ProfileDefaults | undefined;
  readonly shouldApplyProfileDefaults?: boolean | undefined;
}
export function useArtworkSubmissionFormActions(t0) {
  const $ = _c(52);
  const {
    state,
    dispatch,
    profileDefaults,
    shouldApplyProfileDefaults: t1
  } = t0;
  const shouldApplyProfileDefaults = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== dispatch || $[1] !== profileDefaults || $[2] !== shouldApplyProfileDefaults) {
    t2 = () => {
      if (!shouldApplyProfileDefaults) {
        return;
      }
      dispatch({
        type: "APPLY_PROFILE_DEFAULTS",
        payload: profileDefaults ?? {}
      });
    };
    $[0] = dispatch;
    $[1] = profileDefaults;
    $[2] = shouldApplyProfileDefaults;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const applyProfileDefaults = t2;
  let t3;
  if ($[4] !== applyProfileDefaults || $[5] !== dispatch) {
    t3 = () => {
      applyProfileDefaults();
      dispatch({
        type: "SET_STEP",
        payload: SubmissionStep.ARTWORK
      });
    };
    $[4] = applyProfileDefaults;
    $[5] = dispatch;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleContinueFromTerms = t3;
  let t4;
  if ($[7] !== applyProfileDefaults || $[8] !== dispatch) {
    t4 = () => {
      applyProfileDefaults();
      dispatch({
        type: "SET_STEP",
        payload: SubmissionStep.ADDITIONAL_INFO
      });
    };
    $[7] = applyProfileDefaults;
    $[8] = dispatch;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleContinueFromArtwork = t4;
  let t5;
  if ($[10] !== dispatch) {
    t5 = () => {
      dispatch({
        type: "SET_STEP",
        payload: SubmissionStep.ARTWORK
      });
    };
    $[10] = dispatch;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleBackToArtwork = t5;
  let t6;
  if ($[12] !== dispatch) {
    t6 = value => {
      dispatch({
        type: "SET_AGREEMENTS",
        payload: value
      });
    };
    $[12] = dispatch;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const setAgreements = t6;
  let t7;
  if ($[14] !== dispatch) {
    t7 = value_0 => {
      dispatch({
        type: "SET_ADDITIONAL_ACTION_PROMISED",
        payload: value_0
      });
    };
    $[14] = dispatch;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const setAdditionalActionPromised = t7;
  let t8;
  if ($[16] !== dispatch) {
    t8 = (field, value_1) => {
      dispatch({
        type: "SET_TRAIT_FIELD",
        payload: {
          field,
          value: value_1
        }
      });
    };
    $[16] = dispatch;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const updateTraitField = t8;
  let t9;
  if ($[18] !== dispatch) {
    t9 = traitsUpdate => {
      dispatch({
        type: "SET_MULTIPLE_TRAITS",
        payload: traitsUpdate
      });
    };
    $[18] = dispatch;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const setTraits = t9;
  let t10;
  if ($[20] !== dispatch) {
    t10 = entries => {
      dispatch({
        type: "SET_AIRDROP_CONFIG",
        payload: entries
      });
    };
    $[20] = dispatch;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const setAirdropConfig = t10;
  let t11;
  if ($[22] !== dispatch) {
    t11 = paymentInfo => {
      dispatch({
        type: "SET_PAYMENT_INFO",
        payload: paymentInfo
      });
    };
    $[22] = dispatch;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const setPaymentInfo = t11;
  let t12;
  if ($[24] !== dispatch) {
    t12 = batches => {
      dispatch({
        type: "SET_ALLOWLIST_BATCHES",
        payload: batches
      });
    };
    $[24] = dispatch;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const setAllowlistBatches = t12;
  let t13;
  if ($[26] !== dispatch) {
    t13 = additionalMedia => {
      dispatch({
        type: "SET_ADDITIONAL_MEDIA",
        payload: additionalMedia
      });
    };
    $[26] = dispatch;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const setAdditionalMedia = t13;
  let t14;
  if ($[28] !== dispatch) {
    t14 = commentary => {
      dispatch({
        type: "SET_COMMENTARY",
        payload: commentary
      });
    };
    $[28] = dispatch;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  const setCommentary = t14;
  let t15;
  if ($[30] !== dispatch) {
    t15 = aboutArtist => {
      dispatch({
        type: "SET_ABOUT_ARTIST",
        payload: aboutArtist
      });
    };
    $[30] = dispatch;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  const setAboutArtist = t15;
  let t16;
  if ($[32] !== state) {
    t16 = () => {
      const {
        artworkUrl,
        isAdditionalActionPromised,
        operationalData,
        traits
      } = state;
      return {
        imageUrl: artworkUrl,
        traits: {
          ...traits,
          title: traits.title,
          description: traits.description
        },
        operationalData,
        isAdditionalActionPromised
      };
    };
    $[32] = state;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  const getSubmissionData = t16;
  let t17;
  if ($[34] !== state) {
    t17 = () => ({
      mediaSource: state.mediaSource,
      selectedFile: state.selectedFile,
      existingMedia: state.existingMedia,
      externalUrl: state.externalMedia.url,
      externalPreviewUrl: state.externalMedia.previewUrl,
      externalProvider: state.externalMedia.provider,
      externalHash: state.externalMedia.sanitizedHash,
      externalMimeType: state.externalMedia.mimeType,
      isExternalValid: state.externalMedia.isValid
    });
    $[34] = state;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  const getMediaSelection = t17;
  let t18;
  if ($[36] !== getMediaSelection || $[37] !== getSubmissionData || $[38] !== handleBackToArtwork || $[39] !== handleContinueFromArtwork || $[40] !== handleContinueFromTerms || $[41] !== setAboutArtist || $[42] !== setAdditionalActionPromised || $[43] !== setAdditionalMedia || $[44] !== setAgreements || $[45] !== setAirdropConfig || $[46] !== setAllowlistBatches || $[47] !== setCommentary || $[48] !== setPaymentInfo || $[49] !== setTraits || $[50] !== updateTraitField) {
    t18 = {
      getMediaSelection,
      getSubmissionData,
      handleBackToArtwork,
      handleContinueFromArtwork,
      handleContinueFromTerms,
      setAboutArtist,
      setAdditionalActionPromised,
      setAdditionalMedia,
      setAgreements,
      setAirdropConfig,
      setAllowlistBatches,
      setCommentary,
      setPaymentInfo,
      setTraits,
      updateTraitField
    };
    $[36] = getMediaSelection;
    $[37] = getSubmissionData;
    $[38] = handleBackToArtwork;
    $[39] = handleContinueFromArtwork;
    $[40] = handleContinueFromTerms;
    $[41] = setAboutArtist;
    $[42] = setAdditionalActionPromised;
    $[43] = setAdditionalMedia;
    $[44] = setAgreements;
    $[45] = setAirdropConfig;
    $[46] = setAllowlistBatches;
    $[47] = setCommentary;
    $[48] = setPaymentInfo;
    $[49] = setTraits;
    $[50] = updateTraitField;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  return t18;
}